const storage = window.sessionStorage;
const action = callback => {
    try {
        if (typeof callback === 'function') return callback();
    }
    catch (err) {
    }
}
const SiteStorage = {
    setLoaded: () => action(() => storage.setItem('loaded', true)),
    getLoaded: () => action(() => storage.getItem('loaded'))
}

export {
    SiteStorage
}


// WEBPACK FOOTER //
// ./src/storage.js